import React from 'react'

import { Box } from "@mui/material"
import { ButtonIconSeeker, LoadingIconSeeker } from "@ui-seeker/core"
import { useCreateUsersModal, useRequestUserApiKey } from "Pages/Admin/Users/@hooks"
import { editUserId, isLoadingApiKey } from "Pages/Admin/Users/@signals"


export default function actionsColumn() {

	return {
		name: 'uid',
		label: 'Actions',
		options: {
			filter: false,
			customBodyRowRenderLite: value => <ActionsCell id={value}/>,
		}
	}
}


function ActionsCell({ id }) {

	const { onOpenModal } = useCreateUsersModal()
	const { onRequestApiKey } = useRequestUserApiKey()

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
		<ButtonIconSeeker
			icon="edit"
			tooltip="Edit"
			sx={{ color: "warning.main" }}
			onClick={() => {
				editUserId.value = id
				onOpenModal()
			}}
		/>
		<ButtonIconSeeker
			icon="clone"
			tooltip="Clone"
			onClick={() => {
				editUserId.value = id
				onOpenModal(true)
			}}
			sx={{ color: "primary.main" }}
		/>
		{isLoadingApiKey.value !== id && <ButtonIconSeeker
			icon="key-skeleton"
			tooltip="Copy API Key to clipboard"
			onClick={() => {
				onRequestApiKey(id)
			}}
			sx={{ color: "success.dark" }}
		/>}
		{isLoadingApiKey.value === id && <LoadingIconSeeker sx={{ color: "success.dark", fontSize: "0.8vw", }}/>}
	</Box>
}